export const FileUtil = {

    /**
     * Extract the last part of a filename, like the following samples:
     * - data/project_doc/Estriche.png  --> Estriche.png or
     * - data\project_doc\Abräumen.xls  --> Abräumen.xls
     */
    extractFileName(path) {
        if (!path) return "";
        // handles / and \ (Windows & Unix)
        return path.split(/[/\\]/).pop();
    },

    formatFileSize(bytes) {
        if (bytes == null || isNaN(bytes)) return "";

        if (bytes < 1024) {
            return `${bytes} B`;
        }
        if (bytes < 1024 * 1024) {
            return `${(bytes / 1024).toFixed(1)} KB`;
        }
        return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
    },

    formatMimeType(mime) {
        if (!mime) return "";

        if (mime === "application/pdf") return "PDF";
        if (mime.includes("word")) return "Word";
        if (mime.includes("excel") || mime.includes("spreadsheet")) return "Excel";
        if (mime === "image/png") return "PNG";
        if (mime === "image/jpeg") return "JPG";
        if (mime === "text/plain") return "Text";

        return mime;
    },

    base64ToBlob(base64, mimeType) {
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: mimeType });
    },

    fileToBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result.split(",")[1]);
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    },

};
